import { render, staticRenderFns } from "./_base-page-header.vue?vue&type=template&id=4dd742ab&scoped=true&"
import script from "./_base-page-header.vue?vue&type=script&lang=js&"
export * from "./_base-page-header.vue?vue&type=script&lang=js&"
import style0 from "./_base-page-header.vue?vue&type=style&index=0&id=4dd742ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd742ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
